import React from 'react';
import styled from 'styled-components';

const ChooseArea = styled.div`
  display: none;
`;

const ChooseTitle = styled.span`
  color: ${props => props.$color || 'inherit'};
  font-size: 44px;
`;

const ChooseSubtitle = styled.p`
  color: ${props => props.$color || 'inherit'};
`;

const DesignChooseArea = () => {
  return (
    <ChooseArea className="design-choose-area title-box pb-120 pt-120">
      <div className="container container-1680">

        <div className="design-choose-item-wrap">
          <div className="row">
            <div className="col-xl-6">
              <div className="design-choose-item design-choose-item-1 mb-30" data-bg-color="#d00812">
                <ChooseTitle $color="white">Pest Control </ChooseTitle>
                <ChooseSubtitle $color="white">Landscaping</ChooseSubtitle>
              </div>
            </div>
            <div className="col-xl-6">
              <div className="design-choose-item design-choose-item-2 mb-30 mt-170" data-bg-color="#ffd827">
                <ChooseTitle>Tailor on Wheels</ChooseTitle>
                <ChooseSubtitle>Pet Grooming</ChooseSubtitle>
              </div>
            </div>
          </div>
        </div>

        <div className="design-choose-item-wrap">
          <div className="row">
            <div className="col-xl-6">
              <div className="design-choose-item design-choose-item-1 design-choose-item-3 mb-30" data-bg-color="#ffd827">
                <ChooseTitle>Plumber</ChooseTitle>
                <ChooseSubtitle>Electrician</ChooseSubtitle>
              </div>
            </div>
            <div className="col-xl-6">
              <div className="design-choose-item design-choose-item-2 mb-30" data-bg-color="#d00812">
                <ChooseTitle $color="white">Carpenter</ChooseTitle>
                <ChooseSubtitle $color="white">Home Cleaning</ChooseSubtitle>
              </div>
            </div>
          </div>
        </div>

      </div>
    </ChooseArea>
  );
};

export default DesignChooseArea;
